
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { MultiColumnsBlockListItemModel, MultiColumnsBlockSettingsModel } from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import { contentBlockImageSizeModifiersMap } from 'fourwaves-shared/src/services';
import ContentBlockImage from '../ContentBlockImage.vue';
import ContentBlockButton from '../ContentBlockButton.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockImage,
    ContentBlockButton,
  },
})
export default class MultiColumnsBlockListItem extends Vue {
  @Prop({ type: Object, required: true }) readonly item!: MultiColumnsBlockListItemModel;
  @Prop({ type: Object, required: true }) readonly settings!: MultiColumnsBlockSettingsModel;

  get itemClassNames(): string[] {
    return [contentBlockImageSizeModifiersMap[this.settings.imageSize]];
  }
}
